/**
 * @generated SignedSource<<ab167e75062f3595a1c6502dc9a0d777>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPortfolioReportTitleBar_viewer$data = {
  readonly email: string | null;
  readonly actualPersonId: string | null;
  readonly " $fragmentType": "ProjectPortfolioReportTitleBar_viewer";
};
export type ProjectPortfolioReportTitleBar_viewer$key = {
  readonly " $data"?: ProjectPortfolioReportTitleBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPortfolioReportTitleBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioReportTitleBar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9451cf005dc5e6c5763601e15212603c";

export default node;
